import styled from "styled-components";
import * as RD from "../../../components";
import { TimeSlot } from "../../../types/TimeSlot";
import DateHelper from "../../../helpers/DateHelper";
import { TimeSlotButtonStyles } from "../../../types/styles";

const TimeSlotContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export type FullAvailabilityProps = {
  timeSlots: TimeSlot[];
  selectedTimeSlot: TimeSlot | null;
  setSelectedTimeSlot: React.Dispatch<React.SetStateAction<TimeSlot | null>>;
  styles: TimeSlotButtonStyles;
};

export const FullAvailability: React.FC<FullAvailabilityProps> = ({
  timeSlots,
  selectedTimeSlot = null,
  setSelectedTimeSlot,
  styles,
}) => {
  const selectTimeSlot = (timeSlot: TimeSlot) => {
    if (timeSlot.TimeSlot.TimeSlot === selectedTimeSlot?.TimeSlot.TimeSlot) {
      setSelectedTimeSlot(null);
    } else {
      setSelectedTimeSlot(timeSlot);
    }
  };

  if (selectedTimeSlot) {
    const preSelectTimeSlot = timeSlots.find(
      (ts) =>
        DateHelper.sliceTimeSlot(ts) ===
        DateHelper.sliceTimeSlot(selectedTimeSlot)
    );
    if (preSelectTimeSlot) {
      setSelectedTimeSlot(preSelectTimeSlot);
    }
  }

  return (
    <TimeSlotContainer data-id="full-availability">
      {timeSlots?.map((timeSlot, index) => (
        <RD.TimeSlotButton
          key={index}
          text={DateHelper.sliceTimeSlot(timeSlot)}
          onClick={() => selectTimeSlot(timeSlot)}
          isSelected={
            selectedTimeSlot
              ? DateHelper.sliceTimeSlot(timeSlot) ===
                  DateHelper.sliceTimeSlot(selectedTimeSlot) &&
                timeSlot.MicrositeName === selectedTimeSlot.MicrositeName
              : false
          }
          styles={styles}
        />
      ))}
    </TimeSlotContainer>
  );
};

export default FullAvailability;
